import { LocalePortableText, LocaleStringArray, TranslationData } from "@common";
import { toHTML } from "@portabletext/to-html";

export const localizedStringArrayToTranslationData = (localizedStringArray: LocaleStringArray) => {
  if (localizedStringArray === undefined || localizedStringArray === null) {
    return {
      en: "",
      sv: "",
    };
  }
  const translationData: TranslationData = {
    en: localizedStringArray.find((key) => key._key === "en")?.value || "",
    sv: localizedStringArray.find((key) => key._key === "sv")?.value || "",
  };
  return translationData;
};

export const localizedPortableTextToTranslationData = (
  localizedPortableText: LocalePortableText
) => {
  if (localizedPortableText === undefined || localizedPortableText === null) {
    return {
      en: "",
      sv: "",
    };
  }

  const translationData: TranslationData = {
    en: toHTML(localizedPortableText["en"] as any),
    sv: toHTML(localizedPortableText["sv"] as any),
  };
  return translationData;
};
